import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import uuid from 'react-uuid';

import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import country_arr from './common_arr/countries-arr.js';
import business_type_arr from './common_arr/business-type-arr.js';
import s_a from './common_arr/states-arr.js';
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";

function EcommerceProfile() {
	const [state, setstate] = useState(2);
	const [image, setImage] = useState("/assets/media/avatars/blank.png");
	const [file, setfile] = useState([]);
	const [businessTypeList, setBusinessTypeList] = useState([]);

	const [image_location, setimage_location] = useState("");
	const [image_key, setimage_key] = useState("");

	const [unique_id, setUnique_id] = useState(uuid());
	const [ecomorganization_name, setEcomOrganization_name] = useState("");

	const [country_array, setCountryArray] = useState([]);
	const [state_array, set_state_array] = useState([]);
	const [objectAddress, setObjectAddress] = useState({ address_line1: "", address_line2: "", pincode: "", state: "", country: "", city: "", pincode: "" });
	const [objectContact, setObjectContact] = useState({ contact_email: "", support_email: "", phone: "" });
	const [objectMetaTag, setObjectMetaTag] = useState({ ecom_app_meta_tag_name: "", business_type: "", ecom_app_meta_description: "", ecom_app_meta_keywords: "" });
	const [dataFlag, setDataFlag] = useState(false);

	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
	const { theme, dropdownStyleDark } = useTheme();

	var page_name = "ecommerce-profile";

	const { user, read, write, visibility, organization_id, organization_name } = useAuthData(page_name);

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	function handleChange(event) {
		setImage(URL.createObjectURL(event.target.files[0]))
		setfile(event.target.files[0]);
		setMainSubmitButtonState(true);
		const file = event.target.files[0];

		var headers = {
			headers: {
				"Content-Type": "multipart/form-data",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		const body = new FormData();
		body.append('dataFiles', file);
		body.append('organization_id', organization_id);
		//body.append('brand_id', brandId);
		body.append('user_id', user.email);
		body.append('page_name', page_name);
		body.append('type', "logo");
		axios.post(`${process.env.REACT_APP_SERVER_URL}/upload-common-image`, body, headers)
			.then(res => {
				if (res.data && res.data.operation === "success") {
					setimage_location(res.data.message.Location);
					setimage_key(res.data.message.Key);
					setMainSubmitButtonState(false);
				}
			})
	}

	useEffect(() => {
		const business_type = business_type_arr.business_type_arr;
		let temp_category = [];
		business_type.map((main_obj) => {
			var temp_obj = {};
			temp_obj.label = main_obj.category;
			temp_obj.options = main_obj.subcategories.map((x) => { return { label: x, value: x } });
			temp_category.push(temp_obj);
		})
		setBusinessTypeList(temp_category);
	}, []);

	useEffect(() => {
		var obj_array = [];
		var obj2 = {};
		country_arr.country_arr.map((obj, index) => {
			obj2 = {};
			obj2.label = obj;
			if (index > 0) {
				obj2.value = obj;
			}
			else {
				obj2.value = "";
			}
			obj_array.push(obj2);
		})
		//console.log(obj_array);
		setCountryArray(obj_array);
	}, [])

	useEffect(() => {
		async function getEcommerceProfileDetails() {

			var object = {};
			object.email = user.email;

			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-ecommerce-application-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "id": organization_id, "flag": "details" }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();
			console.log("body", body);
			if (body.operation == "success" && body.data.length > 0) {
				setObjectAddress(body.data[0].address_details)
				setObjectContact(body.data[0].contact_details)
				setObjectMetaTag({ ecom_app_meta_tag_name: body.data[0].ecom_app_meta_tag_name, business_type: body.data[0].business_type, ecom_app_meta_description: body.data[0].ecom_app_meta_description, ecom_app_meta_keywords: body.data[0].ecom_app_meta_keywords });
				setEcomOrganization_name(body.data[0].ecom_application_name);
				if (body.data[0].address_details.country !== "") {
					loadState(body.data[0].address_details.country)
				}
				if (body.data[0].application_logo !== undefined) {
					setImage(body.data[0].application_logo);
				}
				setstate(1);
				setDataFlag(true);
			}
			else {
				setstate(1);
			}
		}
		if (read || write) {
			(user.email && visibility && country_array.length > 0) && getEcommerceProfileDetails();
		}
	}, [user, visibility, read, write, country_array])

	const updateorganization = () => {
		var id = user.email;

		var file1 = [];
		file1.push(file.name);
		var values = { "id": id, "unique_id": unique_id, "organization_name": organization_name, "ecomorganization_name": ecomorganization_name, "image_location": image_location, "image_key": image_key, "additional_details": objectMetaTag, "address_details": objectAddress, "contact_details": objectContact, "page_name": page_name, "organization_id": organization_id };
		setMainSubmitButtonState(true)
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		let api = "add-ecommerce-application-info";
		if (dataFlag) {
			api = "update-ecommerce-application-info";
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/${api}`, values, headers).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data && res.data.operation == "success") {
				swal("Great!", "Ecommerce profile saved successfully!", "success").then((value) => {
					window.location.reload();
				});
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		});
	}

	function loadState(country) {
		var selectedCountryIndex = 0;
		country_array.map((obj, index) => {
			if (obj.value == country) {
				selectedCountryIndex = index;
			}
		})
		set_state_array([]);
		var state_arr = s_a.s_a[selectedCountryIndex].split("|");

		var obj_array = [];
		var obj2 = {};

		obj_array.push({ value: "", label: "Select State" });
		for (let i = 0; i < state_arr.length; i++) {
			obj_array.push({ value: state_arr[i], label: state_arr[i] });
		}
		set_state_array(obj_array);
	}

	return (
		<>
			<div>
				<div className="d-flex flex-stack">
					<h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce Profile</h1>
				</div>
				<div>
					{state === 1 ?
						<>
							<div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
								<br />
								<div className="card mb-5 mb-xl-10">
									<div className="card-body pt-9 pb-0">
									</div>
								</div>
								<div className="card mb-5 mb-xl-10">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">Profile Details</h3>
										</div>
									</div>
									<div id="kt_account_profile_details" className="collapse show">
										<form id="kt_account_profile_details_form" className="form">
											<div className="card-body border-top p-9">
												<div className="row mb-6">
													<label className="col-lg-4 col-form-label fw-bold fs-6">Ecommerce Application Logo</label>
													<div className="col-lg-8">
														<div className="image-input image-input-outline" data-kt-image-input="true" style={{ "background-image": "url(assets/media/avatars/blank.png)" }} >
															<div className="image-input-wrapper w-125px h-125px" style={{ "background-image": `url('${image}')` }} ></div>
															<label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="Change profile">
																<i className="bi bi-pencil-fill fs-7"></i>
																<input type="file" name="avatar" accept=".png, .jpg, .jpeg, .svg" onChange={(event) => { handleChange(event) }} />
																<input type="hidden" name="avatar_remove" />
															</label>
														</div>
														<div className="form-text">Allowed file types: png, jpg, jpeg.</div>
													</div>
												</div>
												<div className="row mb-6">
													<label className="col-lg-4 col-form-label required fw-bold fs-6">Ecommerce Application Name</label>
													<div className="col-lg-8">
														<div className="row">
															<div className="col-lg-6 fv-row">
																<input type="text" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="First name" value={ecomorganization_name} onChange={(e) => { setEcomOrganization_name(e.target.value) }} />
																<span id="firstname" className="text-danger font-weight-bold"></span>
															</div>
														</div>
													</div>
												</div>
												<br />
												<div className="d-flex flex-column gap-5 gap-md-7">
													<div className="fs-3 fw-bolder mb-n2">Additional Details</div>
													<div className="d-flex flex-column flex-md-row gap-5">
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className=" form-label">Business Type</label>
															<Select
																styles={theme == 'dark' ? dropdownStyleDark : {}}
																options={businessTypeList}
																onChange={(val) => {
																	setObjectMetaTag({ ...objectMetaTag, business_type: val.value });

																}}
																value={{ label: objectMetaTag.business_type, value: objectMetaTag.business_type }}
															/>
														</div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className="form-label">Meta Tag Name</label>
															<input className="form-control" placeholder="" value={objectMetaTag.ecom_app_meta_tag_name}
																onChange={(e) => {
																	setObjectMetaTag({ ...objectMetaTag, ecom_app_meta_tag_name: e.target.value });
																}} />
														</div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className=" form-label">Meta Description</label>
															<input className="form-control" placeholder="" value={objectMetaTag.ecom_app_meta_description}
																onChange={(e) => {
																	setObjectMetaTag({ ...objectMetaTag, ecom_app_meta_description: e.target.value });
																}} />
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className="form-label">Meta Keyword</label>
															<input type="text" className="form-control" placeholder="" value={objectMetaTag.ecom_app_meta_keywords}
																onChange={(e) => {
																	setObjectMetaTag({ ...objectMetaTag, ecom_app_meta_keywords: e.target.value });
																}} />
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
													</div>
												</div><br />
												<div className="d-flex flex-column gap-5 gap-md-7">
													<div className="fs-3 fw-bolder mb-n2">Contact Details</div>
													<div className="d-flex flex-column flex-md-row gap-5">
														<div className="flex-row-fluid">
															<label className="form-label">Phone</label>
															<input className="form-control" placeholder="" value={objectContact.phone}
																onChange={(e) => {
																	setObjectContact({ ...objectContact, phone: e.target.value });
																}} />
														</div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className=" form-label">Support Email</label>
															<input className="form-control" placeholder="" value={objectContact.support_email}
																onChange={(e) => {
																	setObjectContact({ ...objectContact, support_email: e.target.value });
																}} />
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className="form-label">Contact Email</label>
															<input type="text" className="form-control" placeholder="" value={objectContact.contact_email}
																onChange={(e) => {
																	setObjectContact({ ...objectContact, contact_email: e.target.value });
																}} />
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
													</div>
												</div><br />
												<div className="d-flex flex-column gap-5 gap-md-7">
													<div className="fs-3 fw-bolder mb-n2">Address Details</div>
													<div className="d-flex flex-column flex-md-row gap-5">
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className=" form-label">Address Line 1</label>
															<input className="form-control" name="billing_order_address_1" placeholder="Address Line 1" value={objectAddress.address_line1}
																onChange={(e) => {
																	setObjectAddress({ ...objectAddress, address_line1: e.target.value });
																}} />
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
														<div className="flex-row-fluid">
															<label className="form-label">Address Line 2</label>
															<input className="form-control" name="billing_order_address_2" placeholder="Address Line 2" value={objectAddress.address_line2}
																onChange={(e) => {
																	setObjectAddress({ ...objectAddress, address_line2: e.target.value });
																}} />
														</div>
													</div>
													<div className="d-flex flex-column flex-md-row gap-5">
														<div className="flex-row-fluid">
															<label className="form-label">City</label>
															<input className="form-control" name="billing_order_city" placeholder="" value={objectAddress.city}
																onChange={(e) => {
																	setObjectAddress({ ...objectAddress, city: e.target.value });
																}} />
														</div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className=" form-label">Postcode</label>
															<input className="form-control" name="billing_order_postcode" placeholder="" value={objectAddress.pincode}
																onChange={(e) => {
																	setObjectAddress({ ...objectAddress, pincode: e.target.value });
																}} />
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
														<div className="fv-row flex-row-fluid fv-plugins-icon-container">
															<label className="form-label">GstIn</label>
															<input type="text" className="form-control" placeholder="" name="last-name" id="GstIn" value={objectAddress.GstIn}
																onChange={(e) => {
																	setObjectAddress({ ...objectAddress, GstIn: e.target.value });
																}} />

															<div className="fv-plugins-message-container invalid-feedback"></div></div>
													</div>
													<div className="row mb-5">
														<div className="col-md-6 fv-row">
															<label className=" form-label">Country</label>
															<div className="form-floating border rounded" data-select2-id="select2-data-360-ehcv">
																<label for="kt_ecommerce_edit_order_billing_country">Select a country</label>
															</div>
															{objectAddress.country == "" ?
																<Select
																	styles={theme == 'dark' ? dropdownStyleDark : {}}
																	options={country_array}
																	onChange={(val) => {
																		setObjectAddress({ ...objectAddress, country: val.value });
																		loadState(val.value);

																	}}
																	value={country_array.filter(option =>
																		option.value == objectAddress.country)[0]}

																/>
																:
																<Select
																	styles={theme == 'dark' ? dropdownStyleDark : {}}
																	options={country_array}
																	onChange={(val) => {
																		setObjectAddress({ ...objectAddress, country: val.value });
																		loadState(val.value);

																	}}
																	value={country_array.filter(option =>
																		option.value == objectAddress.country)[0]}
																//isDisabled
																/>
															}
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
														<div className="col-md-6 fv-row">
															<label className=" form-label">State</label>
															<div className="form-floating border rounded" data-select2-id="select2-data-360-ehcv">
																<label for="kt_ecommerce_edit_order_billing_country">Select state</label>
															</div>
															{objectAddress.state == "" ?
																<Select
																	styles={theme == 'dark' ? dropdownStyleDark : {}}
																	name="state"
																	id="state"
																	options={state_array}
																	value={
																		state_array.filter(option =>
																			option.value == objectAddress.state)[0]
																	}
																	onChange={(val) => {
																		setObjectAddress({ ...objectAddress, state: val.value });
																	}}
																	disabled="true"
																/>
																:
																<Select
																	styles={theme == 'dark' ? dropdownStyleDark : {}}
																	name="state"
																	id="state"
																	options={state_array}
																	value={
																		state_array.filter(option =>
																			option.value == objectAddress.state)[0]
																	}
																	onChange={(val) => {
																		setObjectAddress({ ...objectAddress, state: val.value });
																	}}
																//isDisabled
																/>
															}
															<div className="fv-plugins-message-container invalid-feedback"></div></div>
													</div>
												</div>
											</div>
											<div className="card-footer d-flex justify-content-end py-6 px-9">
												<form >
													{
														write == 1 &&
														<button type="button" className="btn btn-primary rounded" onClick={updateorganization} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">{dataFlag ? <>Update</> : <>Save</>} Changes</span>
															<span className="indicator-progress">Please wait...
																<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
													}
												</form>
											</div>
										</form>
									</div>
								</div>
								<br />
							</div>
						</>
						:
						<div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
							<br />

							{state == 2 ?
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								:
								<PageError />
							}


							<br />
						</div>
					}
				</div>
			</div>
		</>
	);
}
export default EcommerceProfile;